"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'payment.confirmed.title': '支付成功！',
    'payment.confirmed.message': '感谢您的付款。您的交易已成功完成。',
    'payment.confirmed.details': '支付详情',
    'payment.confirmed.date': '支付日期',
    'payment.confirmed.paymentIntent': '支付意图ID',
    'payment.confirmed.fetchError': '无法获取支付详情',
    'payment.confirmed.unknownProvider': '未知提供商',
    'payment.confirmed.accountUpgraded': '账户升级成功',
    'payment.confirmed.accountUpgradedMessage': '您的账户已升级，新功能现已可用。',
    'payment.confirmed.nextSteps': '下一步？',
    'payment.confirmed.nextStepsMessage': '您现在可以开始使用升级功能。探索AI聊天、创建头像并管理您的知识库。',
    'payment.confirmed.startChatting': '开始聊天',
    'payment.confirmed.viewAccount': '查看账户',
    'payment.confirmed.backHome': '返回首页',
    'payment.confirmed.receiptInfo': '收据已发送到您的邮箱地址。您也可以从账户设置中下载。',
};
